export default __webpack_public_path__ + "beer-jar-black-silhouette.png";